import React, { useState, useContext, useEffect } from 'react'
import {useTable,  useBlockLayout, useResizeColumns, usePagination, useSortBy, useFilters}  from 'react-table';
import { convertUTCDateStringToLocalDateWithFormatDDMMMYYHH24MISS, convertLocalDateToDisplayToday, convertLocalDateWithFormatDDMMMYY} from '../../vtUtil';
import { AppRelevantDataContext } from '../../AppContext';
import { FaSearch}  from 'react-icons/fa';
import { FaArrowDownLong, FaArrowUpLong } from 'react-icons/fa6';
import '../CSS/VcUserProfileDeviceDetails.css';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { FaQrcode } from 'react-icons/fa';
import {QrScanner} from '@yudiel/react-qr-scanner';
import axios from 'axios';
import {IDS_DeviceID, IDS_DeviceName, IDS_status, IDS_OwnerEmailID, IDS_SubscriptionEndDate,IDS_Download,IDS_DownloadAllData,IDS_DownloadFilteredData} from '../../VcLanguage'
import { getAPIHostURL } from '../../ClientConfig';
import { Modal, ModalHeader, ModalBody} from 'reactstrap';
import { Pagination, Select } from 'antd';
import { CSV_COLUMN_SEPERATOR, CSV_LINE_SEPERATOR} from '../../VcConstants';

// Define a default UI for filtering
function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length
  
    return (
        <div style={{textOverflow: "ellipsis", whiteSpace: "nowrap", paddingLeft: "0.1rem", paddingRight: "0.3rem"}}>
            <FaSearch style={{marginRight:"0.3rem",color:"var(--secondaryColor)", fontSize:"1rem"}}/>
            <input
                 value={filterValue || ''}
                     onChange={e => {
                       setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
                     }}
                placeholder= "Search"
                style={{fontSize:"0.9rem",width: "85%", height:"100%", padding: "0.3rem", border:"1px solid rgba(0,0,0,.1)"}}
            />
        </div>
    );
}

// Create a default prop getter
const defaultPropGetter = () => ({})

const ReactTable = ({ columns, data, passedStateVariables,onFilteredDataChange}) => {

    // Allows overriding or adding additional filter types for columns to use
    const filterTypes = React.useMemo(
        () => ({
            text: (rows, id, filterValue) => {
            return rows.filter(row => {
                const rowValue = row.values[id]
                return rowValue !== undefined
                ? String(rowValue)
                    .toLowerCase()
                    .startsWith(String(filterValue).toLowerCase())
                : true
            })
            },
        }),
        []
    );

    // This is particularly useful for adding global column properties.
    const defaultColumn = React.useMemo(
        () => ({
            minWidth: 30,
            width: 450,
            Filter: DefaultColumnFilter,
        }),
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        prepareRow,
        state: {pageIndex, pageSize},
        getRowProps = defaultPropGetter,
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            // set page size based on tables
            initialState: { pageSize: 10},
            filterTypes,
        },
        useBlockLayout,
        useResizeColumns,
        useFilters,
        useSortBy,
        usePagination,
    );
    useEffect(() => {
        if (onFilteredDataChange) {
            const filteredData = rows.map(row => row.original);
            onFilteredDataChange(filteredData);
        }
    }, [rows]);

    //uses the table header group props for the empty rows so resizing and flex layout still works
    const createEmptyRow = (NoData=false) => {
        return(
            <tr className = "tr"
                style= {{
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                }}
            >
                <td className = "td"
                >
                    {NoData == true?
                    <div><span>&nbsp;{!passedStateVariables[0] ? "No Data Found." : ""}</span></div>
                    :
                    <div><span>&nbsp;</span></div>
                    }
                </td>
            </tr>
                
        )
    };

    //creating empty padding cells
    const getEmptyRow = () => {
        let emptyRows = [];

        if(page.length%pageSize !== 0 && !canNextPage){
            for (let i = 0; i < (pageSize - page.length%pageSize); i++)
                emptyRows.push(createEmptyRow(false));
        }

        if(data.length === 0 || page.length === 0){
            for (let i = 0; i < pageSize; i++){
                if(i == 0){
                    emptyRows.push(createEmptyRow(true));
                } else{
                    emptyRows.push(createEmptyRow(false));
                }
            }
        }

        return emptyRows
    };

    return (
        <div>
            <div className='tableWrap'> 
                <table  {...getTableProps()}  style={{overflow:'auto'}} >
                    <thead>
                        {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()} className="trForHeader" >
                            {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps(column.getSortByToggleProps())} className="tdForHeader">
                                <div className='Header'>
                                    {column.render('Header') }
                                    <div className='fa' >
                                        {column.isSorted
                                        ? column.isSortedDesc
                                            ? <FaArrowDownLong />
                                            : <FaArrowUpLong />
                                        : ''}
                                    </div>
                                </div>
                                <div
                                    {...column.getResizerProps()}
                                    className={`resizer ${
                                        column.isResizing ? 'isResizing' : ''
                                    }`}
                                    // to stop other clicking events when resizing
                                    onClick={(event)=> event.stopPropagation()}
                                />
                            </th>
                            ))}
                        </tr>
                        ))}
                    </thead>

                    <thead >
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}  className="trforSearchField">
                                {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps()} className="tdForSearchField">
                                    <div>{column.canFilter ? column.render('Filter') : null}</div>
                                </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()} >
                        {page.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps(getRowProps(row))}
                                    className = "tr" 
                                    style={{
                                        cursor: '',
                                        background: '',
                                        color: 'black',
                                        alignItems: "center",
                                    }}  
                                >
                                    {row.cells.map(cell => {
                                    return <td {...cell.getCellProps(
                                        [
                                            {style: cell.column.style,},
                                        ]
                                    )} 
                                    className="td">{cell.render("Cell")}</td>;
                                    })}
                                </tr>
                            );
                        })}
                        {getEmptyRow()}
                    </tbody>
                </table>
            </div>

            <div className='w-100 d-flex justify-content-end antdPagination'>
                <div className='d-flex py-1 justify-content-end align-items-center'>
                    <Pagination showQuickJumper 
                        defaultCurrent={pageIndex + 1} 
                        total={pageOptions.length * 10}
                        // total={10 * 10} 
                        onChange={(page) => gotoPage(page - 1)} 
                        showSizeChanger={false}
                        current={pageIndex + 1} 
                    />

                    <Select
                        style={{ marginRight: "1rem", marginLeft: "1.5rem" }}
                        aria-label="rows per page"
                        className="paginationDropdown mySelector"
                        value={pageSize} // Assuming quickTrackParam is the state variable holding the selected value
                        onChange={e => setPageSize(Number(e))} 
                        options={[
                            {
                                label: "5 rows",
                                value: 5
                            },
                            {
                                label: "10 rows",
                                value: 10
                            },
                            {
                                label: "20 rows",
                                value: 20
                            },
                            {
                                label: "25 rows",
                                value: 25
                            },
                            {
                                label: "100 rows",
                                value: 100
                            }
                        ]} // Assuming options is the array of options for the Select component
                    />
                </div>
            </div>
        </div>
    );
};

function VcUserProfileDeviceDetails (props) {

    const context = useContext(AppRelevantDataContext);
    const t = context.t;
    const filterCaseInsensitive = (rows, id, filterValue) => {

        if(id != "lastModifiedTime") {
            return rows.filter(row => {
                const rowValue = row.values[id]
                return rowValue !== undefined
                    ? String(rowValue.toString().toLowerCase()).includes(filterValue.toLowerCase())
                    : false
                });
        } else {
            return rows.filter(row => {
                let splittedStr = row.values[id].split(" ");
                const rowValue = row.values[id]

                if(String("Today".toString().toLowerCase()).includes(filterValue.toLowerCase()) &&
                            new Date(rowValue).getDate().toString().toLowerCase() == new Date().getDate().toString().toLowerCase() &&
                            new Date(rowValue).getMonth().toString().toLowerCase() == new Date().getMonth().toString().toLowerCase() &&
                            new Date(rowValue).getFullYear().toString().toLowerCase() == new Date().getFullYear().toString().toLowerCase()
                ) {
                    // Only for the case where the string entered in the filter box is present in cell
                    // then show all the rows which includes the input string in the final result (by returning true)
                    // It will return only those rows which contains a current date.                
                    return true;
                } else if(new Date(rowValue).getDate().toString().toLowerCase() == new Date().getDate().toString().toLowerCase() &&
                            new Date(rowValue).getMonth().toString().toLowerCase() == new Date().getMonth().toString().toLowerCase() &&
                            new Date(rowValue).getFullYear().toString().toLowerCase() == new Date().getFullYear().toString().toLowerCase() &&
                            String(splittedStr[1].toString().toLowerCase()).includes(filterValue.toString().toLowerCase()) ) {
                    // only for A "Today" case where Searching will always happens in a Time String.
                    return true;
                } else if(new Date(rowValue).getDate().toString().toLowerCase() == new Date().getDate().toString().toLowerCase() &&
                            new Date(rowValue).getMonth().toString().toLowerCase() == new Date().getMonth().toString().toLowerCase() &&
                            new Date(rowValue).getFullYear().toString().toLowerCase() == new Date().getFullYear().toString().toLowerCase()
                ) {
                    // It will return only those rows which should not contains a current date.
                    return false;
                }
                    else {
                    return String(rowValue.toString().toLowerCase()).includes(filterValue.toLowerCase())
                }
            });
        }
    };
                
    const [state, setState] = useState({
        // showModalForSelectedStateProductionInventory: false,
        backdrop:'static',
        noDataFound: "",
        filteredData: [], 
        data : [],
        columns: [],
        errors: { 
            others: '',
        },
    });

    const columns = React.useMemo(()=> [
            {
                Header:() => <div className="AlertLogTableHeader">{t(IDS_DeviceID)}</div>,  
                accessor: 'deviceID',
                width: 190,
                filter: filterCaseInsensitive,
                style: ({
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                }),
            },
            {
                Header:() => <div className="AlertLogTableHeader">{t(IDS_DeviceName)} </div>,  
                accessor: 'deviceName', 
                width: 250,
                filter: filterCaseInsensitive,
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
              
            },
            {
            
                Header:() => <div className="AlertLogTableHeader">{t(IDS_OwnerEmailID)}</div>,  
                accessor: 'deviceOwnerEmail',
                width: 230,
                filter: filterCaseInsensitive,
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
                
            },
            {
                Header:() => <div className="AlertLogTableHeader">{t(IDS_status)}</div>,  
                accessor: 'deviceStatus',
                width: 250,
                filter: filterCaseInsensitive,
                Cell: ({ value }) => value === "-" ? "-" : t(value),
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
                
            },
            
            {
                Header:() => <div className="AlertLogTableHeader">{t(IDS_SubscriptionEndDate)}</div>, 
                accessor: 'subscriptionEndTime',
                width: 230,
                filter: filterCaseInsensitive,
                sortType: (firstRow, secondRow, columnId) => {
                    const rowFirst = firstRow.original[columnId] == null ? "" : new Date(firstRow.original[columnId].toLowerCase()).getTime();
                    const rowSecond = secondRow.original[columnId] == null ? "" : new Date(secondRow.original[columnId].toLowerCase()).getTime();
                    return rowFirst > rowSecond ? 1 : -1
                },
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
                
            }   
        ]
    ,[t])
    
    
    useEffect(() => {
        if (props.deviceType) {
            getLoggedInUserVisibleActiveAndBlockDeviceInfo(props.deviceType);
        }
    }, [props.deviceType]);



    const getLoggedInUserVisibleActiveAndBlockDeviceInfo = (type) => {

       let modifiedState = { ...state };
        modifiedState.data = [];
        modifiedState.errors.others = "";
        modifiedState.noDataFound = "";
        setState({ ...modifiedState });

        const email = context.loggedInUserInfo.userID;
        let invokedFrom = "";

        switch (type) {
            case "OWNED":
                invokedFrom = "OwnedDevices";
                break;
            case "ACTIVE":
                invokedFrom = "ActiveDevices";
                break;
            case "BLOCKED":
                invokedFrom = "BlockedDevices";
                break;
            default:
                invokedFrom = "VisibleDevices";
                break;
    }

        const jsonBody = {
            OwnerUserID: email,
            InvokedFrom: invokedFrom, 
        };
        

        axios.post(`${getAPIHostURL()}/wclient/getLoggedInUserVisibleActiveAndBlockDeviceInfo`, jsonBody)
        .then(response => {
            if(response.data.code == 'SUCCESS') {    

                if(response.data.LoggedInUserDeviceDetailsResponse == null || response.data.LoggedInUserDeviceDetailsResponse.length <= 0) {
                    modifiedState.noDataFound = "No Product Data Found.";
                } else {
                    let tableData = [];
                                            
                    // React table checks using referential integrity. So if you do not create a
                    // new array (but just add to the existing array), the change detection will not trigger.
                    // So create a brand new array from existing Customer Details data.
                    // tableData = [...modifiedState.data]

                    const DevicesReport = response.data.LoggedInUserDeviceDetailsResponse;
                
                    for(let i = 0; i < DevicesReport.length; i++) {
                        const DeviceDetails = DevicesReport[i];
                        // let convertedSubscriptionEndTime = convertUTCDateStringToLocalDateWithFormatDDMMMYYHH24MISS(DeviceDetails.SubscriptionEndDtTm);
                        let convertedSubscriptionEndTime = DeviceDetails.SubscriptionEndDtTm ? convertUTCDateStringToLocalDateWithFormatDDMMMYYHH24MISS(
                            DeviceDetails.SubscriptionEndDtTm)
                            : "-";
                        console.log("convertedSubscriptionEndTime",convertedSubscriptionEndTime);
                        let singleBlockDeviceDetails = {
                            deviceID: DeviceDetails.DeviceID == null || DeviceDetails.DeviceID == "" ? "-" : DeviceDetails.DeviceID,
                            deviceName: DeviceDetails.DeviceName == null || DeviceDetails.DeviceName == "" ? "-" : DeviceDetails.DeviceName,
                            deviceOwnerEmail:  DeviceDetails.DeviceOwnerEmail == null || DeviceDetails.DeviceOwnerEmail == "" ? "-" : DeviceDetails.DeviceOwnerEmail,
                            deviceStatus: DeviceDetails.Reason == null || DeviceDetails.Reason == "" ? "-" : DeviceDetails.Reason,
                            subscriptionEndTime: convertedSubscriptionEndTime == null || convertedSubscriptionEndTime.length <= 0 ? "" : convertedSubscriptionEndTime,
                        };
                        tableData.push(singleBlockDeviceDetails);
                    } 

                    modifiedState.data = tableData;
                    
                }
            } else {
                if(response.data.code == 'SQL_ERROR') {
                    // Tell the user that Server is experiencing errors
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                } else if(response.data.code == 'USER_DEVICE_VISIBLE_ACTIVE_BLOCKED_INFO_MISSING'){
                    modifiedState.errors.others = 'No devices Present for this User Email ID';
                } else {
                    console.log('Should not reach here');
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                }
            }
            setState({...modifiedState});
        })
        .catch(error => {
            console.log(error);
            console.log("Network error:");
            if (axios.isCancel(error)) {
                console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
            } else {
                modifiedState.errors.others = 'Network issues.\nCheck your Internet and Try again later.';
                setState({...modifiedState});
            }
        })
    }

    

    const menu = (
        <Menu
            onClick={({ key }) => {
                if (state.data && state.data.length > 0) {
                    if (key === 'filtered') {
                        DownloadCsv(state.filteredData);
                    } else if (key === 'all') {
                        DownloadCsv(state.data);
                    }
                }
            }}
            items={
                state.filteredData.length === state.data.length
                    ? [
                        {
                            key: 'all',
                            label: t(IDS_DownloadAllData),
                        }
                    ]
                    : [
                        {
                            key: 'filtered',
                            label: t(IDS_DownloadFilteredData),
                        },
                        {
                            key: 'all',
                            label: t(IDS_DownloadAllData),
                        }
                    ]
            }
        />
    );
    const DownloadCsv = (inCsvData) => {      
    
        let modifiedState = state;

        // let arrColumnKeys = ["Device Name", "Owner Email ID", "Status", "Subscription End Time"];
        let arrColumnKeys = [t(IDS_DeviceName), t(IDS_OwnerEmailID), t(IDS_status), t(IDS_SubscriptionEndDate)];

        let strCsvHeaderLine = t(IDS_DeviceID);
        let arrCsvAllLines = []; // All data lines having a "CRLF" at the beginning
        let strSingleCsvDataLine = "";
        let strColumnName = "";
        modifiedState.csvData = [];

        // Create rest of the columns in the header
        let noOfParams = arrColumnKeys.length;
        for (let j=0; j<noOfParams; j++) {
            strColumnName = arrColumnKeys[j];
            strCsvHeaderLine += (CSV_COLUMN_SEPERATOR + strColumnName);
        }

        let receivedAllBlockDevicesReport = inCsvData;
        let receivedAllBlockDevicesReportLen = inCsvData.length;
        let allInstanceInfo = [];

        // First push the header CSV line
        arrCsvAllLines.push(strCsvHeaderLine);

        for(let i = 0; i < receivedAllBlockDevicesReportLen; i++) {

            let singleInstanceInfo = {
                deviceID: receivedAllBlockDevicesReport[i]["deviceID"],
                deviceName: receivedAllBlockDevicesReport[i]["deviceName"],
                deviceOwnerEmail: receivedAllBlockDevicesReport[i]["deviceOwnerEmail"],
                deviceStatus: receivedAllBlockDevicesReport[i]["deviceStatus"],
                subscriptionEndTime: receivedAllBlockDevicesReport[i]["subscriptionEndTime"],
            }

            allInstanceInfo.push(singleInstanceInfo);

            strSingleCsvDataLine = CSV_LINE_SEPERATOR +
                ((receivedAllBlockDevicesReport[i]["deviceID"] == null) ? '' : receivedAllBlockDevicesReport[i]["deviceID"] ) +
                CSV_COLUMN_SEPERATOR +
                ( (receivedAllBlockDevicesReport[i]["deviceName"] == null) ? '' : receivedAllBlockDevicesReport[i]["deviceName"] ) +
                CSV_COLUMN_SEPERATOR +
                ( (receivedAllBlockDevicesReport[i]["deviceOwnerEmail"] == null) ? '' : receivedAllBlockDevicesReport[i]["deviceOwnerEmail"] ) +
                CSV_COLUMN_SEPERATOR +
                ( (receivedAllBlockDevicesReport[i]["deviceStatus"] == null) ? '' : t(receivedAllBlockDevicesReport[i]["deviceStatus"] )) +
                CSV_COLUMN_SEPERATOR +
                ((receivedAllBlockDevicesReport[i]["subscriptionEndTime"] == null) ? '' : receivedAllBlockDevicesReport[i]["subscriptionEndTime"] ) ;

            arrCsvAllLines.push(strSingleCsvDataLine);
        }

        modifiedState.csvData = allInstanceInfo;
        // Create CSV File and fill it
        let bFileCreationStatus = createAndFillCsvFile(arrCsvAllLines);

        alert(`User Profile Report download has started. Check your Browser's status bar or Downloads Folder.`);
    }

    const createAndFillCsvFile = (inarrCsvAllLines) => {

        let retVal = true;

        let fileName = "";

        let currentDate = convertLocalDateWithFormatDDMMMYY(new Date());

        fileName = "UserProfileDeviceData " + currentDate.split(" ")[0]+ ".csv";

        let link = document.createElement('a');
        link.setAttribute('download', fileName);
        link.href = makeTextFile(inarrCsvAllLines);
        document.body.appendChild(link);

        // wait for the link to be added to the document
        window.requestAnimationFrame(function () {
            let event = new MouseEvent('click');
            link.dispatchEvent(event);
            document.body.removeChild(link);
        });

        // Return true to indicate that operation performed successfully (in future any failures in 
        // the previous calls can be checked to return false)
        retVal = true;
        return retVal;
    }

    const makeTextFile = (arrText) =>  {

        let data = new Blob(arrText, {type: 'text/plain'});
        let modifiedState = state;

        // If we are replacing a previously generated file we need to
        // manually revoke the object URL to avoid memory leaks.
        if (modifiedState.textFile !== null) {
            window.URL.revokeObjectURL(modifiedState.textFile);
        }

        modifiedState.textFile = window.URL.createObjectURL(data);

        // Return a URL you can use as an href
        return modifiedState.textFile;
    }    
    return (
    <Modal isOpen={props.isOpen} toggle={props.toggle} size="xl">
        <ModalHeader toggle={props.toggle} > 
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                {/* Left Title */}
                <div>{props.title}</div>

                {/* Right Controls (Download button) */}
                <div style={{marginLeft: "auto" }}>
                    <Dropdown overlay={menu} trigger={['click']}>
                        <button
                            className="btn-sm download-btn-responsive"
                            style={{
                                backgroundColor: "var(--primaryColor)",
                                color: "#fff",
                                border: "none",
                                marginLeft: "800px",
                                padding: "8px 12px",
                                borderRadius: "4px",
                                fontWeight: 700,
                                cursor: "pointer",
                                fontSize: "0.85rem"
                            }}
                        >
                            {t(IDS_Download)}
                            <DownOutlined style={{ paddingLeft: "0.4rem", fontSize: '13px' }} />
                        </button>
                    </Dropdown>
                </div>

            </div>
        </ModalHeader>
        <ModalBody>
            <div className="border border-3 ReactTableStyle">
                <ReactTable 
                    columns={columns} 
                    data={state.data}
                    // as React Table is outside the main function, state varaibles cant be accessed there 
                    // so passing all the state variables on which react table is dependent through passedStateVariable
                    passedStateVariables = {[state.noDataFound]}
                    onFilteredDataChange={(filteredRows) => {
                        setState(prev => ({
                            ...prev,
                            filteredData: filteredRows
                        }));
                    }}
                />
            </div>
        </ModalBody>
    </Modal>
                       
    )
    
}

export default VcUserProfileDeviceDetails;
